<template>
  <div class="feature-buttons">
    <!-- <div
    :class="drtComponents ? 'measuring-tool d-inline-flex' : 'feature-buttons'"
  > -->
    <!-- Return Home Button -->

    <!-- RRHD Conversion Button -->
    <!-- Hidden for the deployement purposes  -->
    <!-- <b-col
        class="px-2"
        v-if="user.org == 3 || user.role == 'USHR Platform Admin'"
      > -->
    <!-- Visible to rivian drt only! -->
    <!-- <MMP_Rivian_RRHD
          :user="this.user"
          :map="map"
          @getVectorlayer="$emit('getVectorlayer', $event)"
          v-if="!drtComponents && homeScreenComponents"
        ></MMP_Rivian_RRHD>
      </b-col> -->
    <div v-if="!homeScreenComponents">
      <b-button
        variant="success"
        @click="$emit('returnHome')"
        title="Home"
        class="py-2 greenBtn"
      >
        <fa :icon="['fas', 'home']" size="lg" />
      </b-button>
    </div>
  </div>
</template>

<script>
import MMP_Extents from './MMP_Extents.vue'
import MMP_Rivian_RRHD from './../MMP_DRT/MMP_Rivian_RRHD.vue'
export default {
  name: 'MMP_FeatureButtons',
  components: {
    MMP_Extents,
    MMP_Rivian_RRHD
  },
  props: [
    'ansiComponent',
    'drtComponents',
    'homeScreenComponents',
    'isAdmin',
    'user',
    'map'
  ]
}
</script>
